<template>
  <div
    ref="rootRef"
    class="ui-segmented"
    :class="{ 'ui-segmented--wrap': wrap, 'has-indicator': hasIndicator }"
    role="radiogroup"
  >
    <span
      class="ui-segmented__indicator ui-motion-move"
      :class="{ 'is-animated': isAnimated }"
      :style="indicatorStyle"
      aria-hidden="true"
    />

    <button
      v-for="(option, index) in options"
      :key="option.value"
      class="ui-segmented__item"
      :class="{ 'is-active': option.value === modelValue }"
      type="button"
      role="radio"
      data-roving-item
      :tabindex="isTabbable(index) ? 0 : -1"
      :aria-checked="option.value === modelValue"
      :disabled="disabled"
      @click="emit('update:modelValue', option.value)"
      @keydown="onKeydown($event, index)"
    >
      {{ option.text }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useRovingSelection } from "@/components/newUi/core/useRovingSelection";
import { useSlidingIndicator } from "@/components/newUi/core/useSlidingIndicator";

export interface UiSegmentedOption {
  value: string | number;
  text: string;
}

const props = withDefaults(
  defineProps<{
    modelValue: string | number | null;
    options: UiSegmentedOption[];
    wrap?: boolean;
    disabled?: boolean;
  }>(),
  {
    wrap: false,
    disabled: false,
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: string | number];
}>();

const { rootRef, isTabbable, onKeydown } = useRovingSelection(
  () => props.options,
  () => props.modelValue,
  (value) => emit("update:modelValue", value),
  () => props.disabled,
);

const { indicatorStyle, hasIndicator, isAnimated } = useSlidingIndicator(
  rootRef,
  () => props.modelValue,
);
</script>
